import React, { SVGProps } from 'react';

export const AlertCircleIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			{...props}
			preserveAspectRatio='xMidYMid meet'
			viewBox='0 0 14 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7.00008 12.8346C10.2217 12.8346 12.8334 10.223 12.8334 7.0013C12.8334 3.77964 10.2217 1.16797 7.00008 1.16797C3.77842 1.16797 1.16675 3.77964 1.16675 7.0013C1.16675 10.223 3.77842 12.8346 7.00008 12.8346Z'
				stroke='#BB2828'
				strokeWidth='0.933333'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7 4.66797V7.0013'
				stroke='#BB2828'
				strokeWidth='0.933333'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7 9.33203H7.00544'
				stroke='#BB2828'
				strokeWidth='0.933333'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
